// check device
var deviceCheck = function() {
	var wmCheck = true; // PC
	var uAgent = navigator.userAgent.toLowerCase();
	var mobilePhones = new Array('iphone','ipad','ipod','android','blackberry','windows ce', 'nokia','webos','opera mini','sonyericsson','opera mobi','iemobile');
	for (var i =0; i<mobilePhones.length; i++){
		if(uAgent.indexOf(mobilePhones[i])>-1){
			wmCheck=false;
		}
	}
	return wmCheck;
};

// check browser
var isBrowserCheck = function() {
	var agt = navigator.userAgent.toLowerCase();
	if (agt.indexOf("chrome") != -1) return 'Chrome';
	if (agt.indexOf("opera") != -1) return 'Opera';
	if (agt.indexOf("staroffice") != -1) return 'Star Office';
	if (agt.indexOf("webtv") != -1) return 'WebTV';
	if (agt.indexOf("beonex") != -1) return 'Beonex';
	if (agt.indexOf("chimera") != -1) return 'Chimera';
	if (agt.indexOf("netpositive") != -1) return 'NetPositive';
	if (agt.indexOf("phoenix") != -1) return 'Phoenix';
	if (agt.indexOf("firefox") != -1) return 'Firefox';
	if (agt.indexOf("safari") != -1) return 'Safari';
	if (agt.indexOf("skipstone") != -1) return 'SkipStone';
	if (agt.indexOf("netscape") != -1) return 'Netscape';
	if (agt.indexOf("mozilla/5.0") != -1) return 'Mozilla';
	if (agt.indexOf("msie") != -1) {
		var rv = -1;
		if (navigator.appName == 'Microsoft Internet Explorer') {
			var ua = navigator.userAgent;
			var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
			if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
		}
		return 'Internet Explorer '+rv;
	}
};

// is in screen
var isInScreen = function(t, b) {
	var sTop = $(window).scrollTop();
	var bTop = $(window).scrollTop() + $(window).height();
	if(((t>sTop || b<bTop) && !(t>bTop || b<sTop)) || (t<sTop && b>bTop)) {
		return true;
	} else {
		return false;
	}
};

/*
 * Smooth Scroll
 */
var useScrollSmooth = false;
(function($) {
	var isMobile = !deviceCheck();

	if(isMobile) {
		$('body').addClass('touch').removeClass('no-touch');
	} else {
		$('body').removeClass('touch').addClass('no-touch');
	}

	/*
	if(isMobile || isBrowserCheck()=='Firefox') {
		return false;
	}

	if (window.addEventListener) {
		window.addEventListener('DOMMouseScroll', wheel, false);
		if (isBrowserCheck()=='Chrome')
		{
			window.addEventListener('wheel', wheel, {passive: false});
		}
	}
	window.onmousewheel = document.onmousewheel = wheel;
	function wheel(event) {
		if(useScrollSmooth) {
			var delta = 0;
			if (event.wheelDelta) delta = event.wheelDelta / 30; // lower is faster
			else if (event.detail) delta = -event.detail / 3;
			handle(delta);
			if (event.preventDefault) event.preventDefault();
			event.returnValue = false;
		} else {
			return true;
		}
	}
	var goUp = true;
	var end = null;
	var interval = null;

	function handle(delta) {
		if(useScrollSmooth) {
			var animationInterval = 15; //lower is faster
			var scrollSpeed = 10; //lower is faster
			if (end == null) {
				end = $(window).scrollTop();
			}
			end -= 20 * delta;
			goUp = delta > 0;
			if (interval == null) {
				interval = setInterval(function () {
					if(useScrollSmooth) {
						var scrollTop = $(window).scrollTop();
						var step = Math.round((end - scrollTop) / scrollSpeed);
						if (!useScrollSmooth || scrollTop <= 0 || scrollTop > $(document).height() - $(window).height() || goUp && step > -1 || !goUp && step < 1 ) {
							clearInterval(interval);
							interval = null;
							end = null;
						}
						$(window).scrollTop(scrollTop + step);
					} else {
						if(interval) clearInterval(interval);
						interval = null;
						end = null;
						return false;
					}
				}, animationInterval);
			}
		} else {
			return true;
		}
	}
	*/
})(jQuery);

/*
 * Layer Focus Trap
 */
function focusTrap(obj){
	var focusObj = $(obj).find('a[href], area[href], input:not([disabled]), input:not([readonly]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');
	var focusFirst = focusObj.first();
	var focusLast = focusObj.last();

	focusFirst.focus();

	focusLast.on('keydown', function (e) {
		if ((e.which === 9 && !e.shiftKey)) {
			e.preventDefault();
			focusFirst.focus();
		}
	});
	focusFirst.on('keydown', function (e) {
		if ((e.which === 9 && e.shiftKey)) {
			e.preventDefault();
			focusLast.focus();
		}
	});
}
function focusTrapSet(obj){
	var focusObj = $(obj).find('a[href], area[href], input:not([disabled]), input:not([readonly]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable], video');
	var focusFirst = focusObj.first();
	var focusLast = focusObj.last();

	focusLast.on('keydown', function (e) {
		if ((e.which === 9 && !e.shiftKey)) {
			e.preventDefault();
			focusFirst.focus();
		}
	});
	focusFirst.on('keydown', function (e) {
		if ((e.which === 9 && e.shiftKey)) {
			e.preventDefault();
			focusLast.focus();
		}
	});
}

$(function(){
	if( $('.thinq-section').length == 0 ) return;

	$(window).on('load', function(){
		//useScrollSmooth = true;
	});
});

// all products layer
$(function(){
	var $allProductBtn = $('.quick-all .btn-all-products');
	var $allProductLayer = $('.all-product-layer');
	$allProductBtn.on('click',function(e){
		e.preventDefault();

		useScrollSmooth = false;
		$('body').addClass('body-scroll-hidden-fix');

		$('.all-product-layer').show().stop().animate({'opacity':'1'}, 500);
		focusTrap('.all-product-layer');
	});
	// all products layer close
	$allProductLayer.find('.btn-close').on('click', function(e){
		e.preventDefault();

		useScrollSmooth = true;
		$('body').removeClass('body-scroll-hidden-fix');

		$allProductLayer.stop().animate({'opacity':'0'}, 500, function(){
			$allProductLayer.hide();
			//$stickyArea.find('.menu-products .title').focus();
		});
	});

	$(window).scroll(function(){
		var $quickArea = $('.quick-all');
		if(window.innerWidth < 768) {
			if( !$quickArea.hasClass('call-yet') ) {
				setTimeout(function(){
					$('.quick-all').addClass('active');
				},1000);
			}
		}
	})
})
